import SectionHeader from './SectionHeader';
import { liveRooms, categories } from '../../../mocks/gossip';

function fmt(n: number) {
  if (n >= 10000) return `${(n / 10000).toFixed(1)}w`;
  return `${n}`;
}

export default function LiveRooms() {
  return (
    <section id="live" className="scroll-mt-20 bg-background-100/70 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeader
          eyebrow="现场直播间"
          title="围观现场 · 前排蹲好"
          desc="每个正在发酵的热点事件都有一个实时更新的围观房间，弹幕、评论区与各方回应同步滚屏，蹲后续不迷路。"
        />

        <div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-4">
          {liveRooms.map((r) => (
            <article
              key={r.id}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-shadow hover:shadow-md"
            >
              <div className="relative h-40 w-full overflow-hidden">
                <img
                  src={r.image}
                  alt={`${r.name}围观现场 - 呱呱吃瓜实时直播`}
                  title={`${r.name} · 前排围观现场`}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 inline-flex items-center gap-1 whitespace-nowrap rounded-md bg-primary-600 px-2 py-1 text-xs font-medium text-background-50">
                  <span className="relative flex h-2 w-2">
                    <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-background-50 opacity-75"></span>
                    <span className="relative inline-flex h-2 w-2 rounded-full bg-background-50"></span>
                  </span>
                  LIVE
                </span>
                <span className="absolute right-3 top-3 inline-flex items-center gap-1 whitespace-nowrap rounded-md bg-background-950/70 px-2 py-1 text-xs text-background-50">
                  <i className="ri-eye-line"></i>
                  {fmt(r.watching)} 人前排
                </span>
              </div>

              <div className="flex flex-1 flex-col p-4 md:p-5">
                <span className="whitespace-nowrap rounded-full bg-background-100 px-2.5 py-0.5 text-xs text-foreground-500">
                  {r.group}
                </span>
                <h3 className="mt-3 text-base font-bold text-foreground-950 transition-colors group-hover:text-primary-600 md:text-lg">
                  <a href="#live">{r.name}</a>
                </h3>
                <p className="mt-1.5 flex-1 text-sm text-foreground-600">{r.desc}</p>

                <div className="mt-4 flex items-center justify-between border-t border-background-100 pt-3">
                  <span className="flex items-center gap-1 whitespace-nowrap text-xs text-foreground-400">
                    <i className="ri-chat-1-line"></i>
                    {fmt(r.replies)} 条回应
                  </span>
                  <button className="flex items-center gap-1 whitespace-nowrap rounded-md bg-primary-500 px-3 py-1.5 text-xs font-medium text-background-50 transition-colors hover:bg-primary-600">
                    <i className="ri-login-circle-line"></i>
                    进现场
                  </button>
                </div>
              </div>
            </article>
          ))}
        </div>

        {/* 吃瓜分类 */}
        <div id="cates" className="mt-14 scroll-mt-20">
          <SectionHeader eyebrow="按口味挑选" title="吃瓜分类" desc="剧集、选秀、商界、红毯……想蹲哪一类前排，直接按分类直达对应瓜田。" />
          <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-6">
            {categories.map((c) => (
              <a
                key={c.id}
                href="#cates"
                className="group flex flex-col items-center rounded-lg border border-background-200 bg-background-50 px-4 py-6 text-center transition-all hover:-translate-y-1 hover:border-primary-200 hover:bg-primary-50"
              >
                <span className="flex h-12 w-12 items-center justify-center rounded-full bg-secondary-100 text-xl text-secondary-700 transition-colors group-hover:bg-secondary-200">
                  <i className={c.icon}></i>
                </span>
                <span className="mt-3 text-sm font-bold text-foreground-900">{c.name}</span>
                <span className="mt-1 text-xs text-foreground-400">{c.desc}</span>
                <span className="mt-2 inline-flex items-center gap-1 whitespace-nowrap text-xs text-accent-600">
                  {c.count} 条瓜
                  <i className="ri-arrow-right-line"></i>
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}